import React from "react";
import "./Link.scss";
import { LinkIcon } from "./LinkIcon";

interface Props {
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  red?: boolean;
  id?: string;
  icon?: boolean;
  className?: string;
}

export const Link: React.FC<Props> = ({ disabled, onClick, children, red, id, icon, className }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onClick();
  };

  const props = {
    id: id,
    className: `link-component ${className}`,
    styles: {
      fontWeight: "bold",
      textAlign: "right",
      color: disabled ? "#777" : red === true ? "#E43232" : "#215383",
      cursor: disabled ? "not-allowed" : "pointer",
    },
    onClick: handleClick,
  };

  return disabled ? (
    <span {...props}>
      {children} {icon ? <LinkIcon /> : null}
    </span>
  ) : (
    <a {...props}>
      {children} {icon ? <LinkIcon /> : null}
    </a>
  );
};
